export const StorageIdUser = 'USER';
export const StorageIdUserAccess = 'USER_ACCESS';
export const DEVICE_CURRENT_PROFILE = 'DEVICE_CURRENT_PROFILE';
export const APP_SETTINGS = 'appSettings';
export const DEVICES = 'DEVICES';
export const VIRTUAL_DEVICE = 'VIRTUAL_DEVICE';
export const VIRTUAL_DEVICE_ID = 'VIRTUAL_DEVICE_ID';
export const VIRTUAL_DEVICE_TOKEN = 'VIRTUAL_DEVICE_TOKEN';
export const UPGRADE_MODAL_DISMISSED_COOKIE = 'cephable_upgrade_modal_dismissed';
export const UPGRADE_MODAL_DISMISSED_COOKIE_EXPIRY_DAYS = 14;
export const AUTOMATION_RULES = 'AUTOMATION_RULES';
export const AI_INTRO_CHOICE = 'ai_intro_choice';
export const RECORD_WORKFLOW_COACH = 'record_workflow_coach';
